import ls from 'local-storage';
import * as CryptoJS from 'crypto-js';

const _saltKey = process.env.VITE_ENCRYPTION_KEY;
const encryptPrefix = '@secure.';

let enableEncryption = process.env.VITE_ENV === 'production';

// disable DECRYPT by magic word
if (localStorage?.getItem('masterKey') === process.env.VITE_DECRYPTION_KEY) {
    enableEncryption = false;
}

function encrypt(value) {
    let data = JSON.stringify(value);
    return CryptoJS.AES.encrypt(data, _saltKey).toString();
}

function decrypt(data) {
    // fall back if data is null
    if (!data) {
        ls.clear();
        window.location.reload();
        return false;
    }

    // check whether it is possible to decrypt the data
    try {
        CryptoJS.AES.decrypt(data, _saltKey).toString(CryptoJS.enc.Utf8)
    } catch (e) {
        localStorage.clear();
        window.location.reload()
    }

    let bytes = CryptoJS.AES.decrypt(data, _saltKey).toString(CryptoJS.enc.Utf8);

    try {
        return JSON.parse(bytes);
    } catch (e) {
        return bytes;
    }
}

export function set(key, value) {
    if (enableEncryption) {
        ls.set(`${encryptPrefix}${key}`, encrypt(value));
    } else {
        ls.set(key, value);
    }
}

export function get(key) {
    if (ls.get(key) || ls.get(`${encryptPrefix}${key}`)) {
        if (enableEncryption) {
            return decrypt(ls.get(`${encryptPrefix}${key}`));
        } else {
            return ls.get(key);
        }
    } else {
        return null;
    }
}

export function remove(key) {
    return ls.remove(enableEncryption ? `${encryptPrefix}${key}` : key);
}

export function clear() {
    ls.clear();
}
